(ns practitest.frontend.components2.statuses-bar
  (:require
    [clojure.string :as str]
    [practitest.frontend.common.i18n :refer [get-translation]]
    [practitest.frontend.components.tooltip :as tooltip]))

(defn statuses-bar [statuses status-color-fn]
  (let [sum (reduce + (map last statuses))]
    [tooltip/mux-tooltip
     {:position "top"}
     (if (empty? statuses)
       (get-translation "generic.label.no-items" "No items")
       (str/join "; "
                 (map (fn [[status count]]
                        (str (symbol status) ": " count))
                      statuses)))
     (fn [props]
       (into [:div.progress props]
             (for [[status cnt] statuses]
               [:div.progress-bar
                {:style {:width            (str (int (* 100 (/ cnt sum))) "%")
                         :background-color (status-color-fn status)}}])))]))